// Based on https://medium.com/javascript-in-plain-english/google-analytics-with-react-router-and-hooks-16d403ddc528
// Modified to use our analytics abstraction layer

import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAnalytics } from '../services/analytics'

export default function useTracking(): void {
  const { listen } = useHistory()
  const analytics = useAnalytics()

  useEffect(() => {
    return listen((location) => {
      analytics.setCurrentScreen(location.pathname)
      analytics.logEvent('page_view', {
        page_location: window.location.href,
        page_path: location.pathname,
      })
    })
  }, [listen, analytics])
}
